import { Capacitor } from '@capacitor/core';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const initPushNotifications = async (token) => {
  if (!Capacitor.isNativePlatform()) {
    console.log('Push notifications only available on native platforms');
    return;
  }

  console.log('PUSH JS: Starting...');

  // Retry multiple times to catch the token whenever it's injected
  const maxRetries = 10;
  const retryDelay = 2000; // 2 seconds between retries

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      await new Promise(resolve => setTimeout(resolve, retryDelay));
      
      const fcmToken = localStorage.getItem('fcm_token');
      console.log(`PUSH JS: Attempt ${attempt}/${maxRetries} - Token:`, fcmToken ? `${fcmToken.substring(0, 30)}... (${fcmToken.length} chars)` : 'null');

      if (fcmToken && fcmToken.length > 100) {
        console.log('PUSH JS: Sending to backend...');
        const response = await axios.post(`${API}/device-token`, {
          token: fcmToken,
          platform: Capacitor.getPlatform()
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('PUSH JS: Success!', response.status);
        return; // Success - exit the retry loop
      }
    } catch (e) {
      console.error('PUSH JS: Error:', e);
    }
  }
  
  console.log('PUSH JS: Failed to get token after all retries');
};

export const unregisterPushNotifications = async (deviceToken, token) => {
  if (!Capacitor.isNativePlatform() || !deviceToken) return;
  try {
    await axios.delete(`${API}/device-token`, {
      data: { token: deviceToken, platform: Capacitor.getPlatform() },
      headers: { Authorization: `Bearer ${token}` }
    });
  } catch (e) {
    console.error('Failed to unregister:', e);
  }
};
